import React, { Component } from 'react';

import ContentPage from 'components/content-page';
import Meta from 'components/meta';
import Wrapper from 'components/wrapper';
import styles from './styles.module.css';

export default class Confidentiality extends Component {
  render() {
    return (
      <ContentPage>
        <Meta title="Confidentiality" description="Charte of confidentiality" />
        <Wrapper>
          <div className={styles.contact}>
            <h2>Mon engagement de confidentialité</h2>
            <p>
              Youcef EL KAMEL s’engage `a respecter scrupuleusement la
              confidentia- lit ́e la plus absolue en ce qui concerne les
              informations et les documents que vous pourriez nous communiquer
              dans le cadre de l’utilisation des applications produit par
              LaYouCeferie.
            </p>
            <p>
              Je reconnais avoir été averti du fait que les renseignements et
              les documents que vous pouvez me fournir sont couverts par le
              secret professionnel et que toute divulgation irrégulière de ces
              informations constituerait un délit réprimé par le code pénal.
            </p>
          </div>
        </Wrapper>
      </ContentPage>
    );
  }
}



// WEBPACK FOOTER //
// ./confidentiality/index.jsx